var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.oidcUser)?_c('div',{staticClass:"aco-grid"},[_c('div',{staticClass:"aco-info-box"},[_c('quick-links')],1),_c('div',{staticClass:"aco-details-box"},[_c('quick-searches')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }